<template>
  <div class="welcome-container">
    <!-- Modal controlado por v-if -->
    <div v-if="true" class="modal fade show" style="display: block; background: rgba(0,0,0,0.5);" tabindex="-1" aria-labelledby="
    dalLabel" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">
              {{ isEditMode ? $t('editar_usuario') : $t('crear_usuario') }}
            </h3>
            <button
              type="button"
              class="btn-close"
              @click="closeModal"
              aria-label="Cerrar"
            >
              <span class="material-icons close-icon" aria-hidden="true">close</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- Formulario -->
            <form @submit.prevent="handleSubmit">
              <div class="form-grid">
                <!-- Nombre Completo -->
                <label for="nombre_completo" class="form-label">
                  {{ $t('nombre_completo') }} <span class="required">*</span>
                </label>
                <input type="text" id="nombre_completo" v-model="form.nombre_completo" class="form-control" required />

                <!-- Nombre de Usuario -->
                <label for="nombre_usuario" class="form-label">
                  {{ $t('nombre_usuario') }} <span class="required">*</span>
                </label>
                <div v-if="isEditMode" class="form-text">
                  {{ form.nombre_usuario }}
                </div>
                <input v-else type="text" id="nombre_usuario" v-model="form.nombre_usuario" class="form-control" required />

                <!-- Email -->
                <label for="email" class="form-label">
                  {{ $t('email') }} <span class="required">*</span>
                </label>
                <input type="email" id="email" v-model="form.email" class="form-control" required />

                <!-- Contraseña -->
                <label for="password" class="form-label" v-if="!isEditMode">
                  {{ $t('contrasena') }} <span class="required">*</span>
                </label>
                <div class="password-container" v-if="!isEditMode">
                  <input :type="showPassword ? 'text' : 'password'" id="password" v-model="form.password" class="form-control" required />
                  <button type="button" class="toggle-password" @click="togglePasswordVisibility" aria-label="Mostrar/Ocultar contraseña">
                    <span class="material-icons">
                      {{ showPassword ? 'visibility_off' : 'visibility' }}
                    </span>
                  </button>
                </div>

                <!-- Confirmar Contraseña -->
                <label for="confirm_password" class="form-label" v-if="!isEditMode">
                  {{ $t('confirmar_contrasena') }} <span class="required">*</span>
                </label>
                <div class="password-container" v-if="!isEditMode">
                  <input :type="showConfirmPassword ? 'text' : 'password'" id="confirm_password" v-model="form.confirm_password" class="form-control" required />
                  <button type="button" class="toggle-password" @click="toggleConfirmPasswordVisibility" aria-label="Mostrar/Ocultar contraseña">
                    <span class="material-icons">
                      {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
                    </span>
                  </button>
                </div>

                <!-- Rol -->
                <label for="rol_id" class="form-label">
                  {{ $t('rol') }} <span class="required">*</span>
                </label>
                <select id="rol_id" v-model="form.rol_id" class="form-control" required>
                  <option value="" disabled>{{ $t('seleccione_rol') }}</option>
                  <option v-for="rol in roles" :key="rol.id" :value="rol.id">
                    {{ rol.nombre }}
                  </option>
                </select>

                <!-- Delegación -->
                <label for="delegacion_id" class="form-label">
                  {{ $t('delegacion') }} <span class="required">*</span>
                </label>
                <select id="delegacion_id" v-model="form.delegacion_id" class="form-control" required>
                  <option value="" disabled>{{ $t('seleccione_delegacion') }}</option>
                  <option v-for="delegacion in delegaciones" :key="delegacion.id" :value="delegacion.id">
                    {{ delegacion.codigo }} - {{ delegacion.nombre }}
                  </option>
                </select>

                <!-- Departamento -->
                <label for="departamento_id" class="form-label">
                  {{ $t('departamento') }} <span class="required">*</span>
                </label>
                <select id="departamento_id" v-model="form.departamento_id" class="form-control" required>
                  <option value="" disabled>{{ $t('seleccione_departamento') }}</option>
                  <option v-for="departamento in departamentos" :key="departamento.id" :value="departamento.id">
                    {{ departamento.nombre }}
                  </option>
                </select>

                <!-- Usuario Responsable -->
                <label for="usuario_responsable_id" class="form-label">
                  {{ $t('usuario_responsable') }}
                </label>
                <select id="usuario_responsable_id" v-model="form.usuario_responsable_id" class="form-control">
                  <option value="">{{ $t('seleccione_usuario_responsable') }}</option>
                  <option v-for="usuario in usuarios" :key="usuario.id" :value="usuario.id">
                    {{ usuario.nombre_completo }}
                  </option>
                </select>

                <!-- Forzar Cambio de Contraseña -->
                <label for="forzar_cambio_contrasena" class="form-label">
                  {{ $t('forzar_cambio_contrasena') }}
                </label>
                <div class="form-check">
                  <input type="checkbox" id="forzar_cambio_contrasena" v-model="form.forzar_cambio_contrasena" class="form-check-input" />
                  <label class="form-check-label" for="forzar_cambio_contrasena">
                    {{ $t('activar') }}
                  </label>
                </div>

                <!-- Bloqueado -->
                <label for="bloqueado" class="form-label">
                  {{ $t('bloqueado') }}
                </label>
                <div class="form-check">
                  <input type="checkbox" id="bloqueado" v-model="form.bloqueado" class="form-check-input" />
                  <label class="form-check-label" for="bloqueado">
                    {{ $t('activar') }}
                  </label>
                </div>
              </div>
              <p class="required-note">
                <span class="required">*</span> {{ $t('campos_obligatorios') }}
              </p>

               <div class="form-actions">
              <button type="submit" class="btn btn-primary">
                {{ isEditMode ? $t('actualizar') : $t('crear') }}
              </button>            
               <button type="button" class="btn-cancel" @click="$emit('close')">{{ $t('cancelar') }}</button>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
import api from '@/api';
import Swal from 'sweetalert2';

export default {
  emits: ['submit', 'close'],
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      roles: [],
      delegaciones: [],
      departamentos: [],
      usuarios: [],
      showPassword: false,
      showConfirmPassword: false,
      errorMessage: '',
      successMessage: '',
      users: [], // Agregado para la tabla de usuarios
    };
  },
  async created() {
    try {
      await this.loadInitialData();
    } catch (error) {
      console.error('Error al cargar los datos iniciales:', error);
      this.showAlert('Error al cargar datos iniciales', 'error');
    }
  },
  methods: {
    async loadInitialData() {
      this.roles = await this.fetchData('/users/roles');
      let delegaciones = await this.fetchData('/delegaciones/activos');
      // Ordenar por código (asumiendo que es string, si es número usa parseInt)
      this.delegaciones = delegaciones.sort((a, b) => a.codigo.localeCompare(b.codigo, 'es', { numeric: true }));
      this.departamentos = await this.fetchData('/users/departamentos');
      
      const usuarios = await this.fetchData('/users');
      this.usuarios = usuarios.data.map(usuario => ({
        id: usuario.id,
        nombre_completo: usuario.nombre_completo,
      }));

      // Cargar usuarios para la tabla
      this.users = await this.fetchData('/users');
    },
    
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    
    async fetchData(endpoint) {
      try {
        // Usar la instancia centralizada api.js (añade token y Accept automáticamente)
        const response = await api.get(endpoint);
        return response.data; // conservar el formato esperado por el resto del componente
      } catch (error) {
        console.error(`Error al cargar datos desde ${endpoint}:`, error);
        throw error;
      }
    },
    
    async handleSubmit() {
      this.errorMessage = '';
      this.successMessage = '';
      
      const userData = {
        nombre_completo: this.form.nombre_completo,
        nombre_usuario: this.form.nombre_usuario,
        email: this.form.email,
        password: this.form.password,
        password_confirmation: this.form.confirm_password,
        rol_id: this.form.rol_id,
        delegacion_id: this.form.delegacion_id,
        departamento_id: this.form.departamento_id,
        usuario_responsable_id: this.form.usuario_responsable_id,
        forzar_cambio_contrasena: this.form.forzar_cambio_contrasena,
        bloqueado: this.form.bloqueado, // Incluir el campo "bloqueado"
      };

      // Validación cliente: evitar emails duplicados entre usuarios
      try {
        const emailToCheck = (this.form.email || '').toString().trim().toLowerCase();

        if (!emailToCheck) {
          this.showAlert(this.$t('email_invalido') || 'Email inválido', 'error');
          return;
        }

        // Asegurarnos de tener la lista de usuarios para comprobar duplicados
        if (!Array.isArray(this.users) || this.users.length === 0) {
          try {
            const loaded = await this.fetchData('/users');
            // fetchData puede devolver { data: [...] } o directamente array según endpoint
            this.users = Array.isArray(loaded) ? loaded : (loaded.data || []);
          } catch (err) {
            // Si falla la carga, continuamos y confiamos en la validación del servidor
            if (import.meta.env && import.meta.env.DEV) console.warn('No se pudieron cargar usuarios para comprobación de email:', err);
          }
        }

        const duplicate = this.users && this.users.find && this.users.find(u => {
          if (!u || !u.email) return false;
          try {
            const ue = (u.email || '').toString().trim().toLowerCase();
            if (ue !== emailToCheck) return false;
            // Si estamos en edición, permitir si es el mismo usuario
            if (this.isEditMode && this.form && this.form.id && Number(u.id) === Number(this.form.id)) return false;
            return true;
          } catch (e) { return false; }
        });

        if (duplicate) {
          const msg = this.$t('email_ya_utilizado') || `El email ${this.form.email} ya está en uso por otro usuario`;
          this.showAlert(msg, 'error');
          return;
        }

      } catch (err) {
        // si algo sale mal en la comprobación, dejamos que el flujo continúe y el servidor valide
        if (import.meta.env && import.meta.env.DEV) console.warn('Error comprobando duplicado de email:', err);
      }

      try {
        const endpoint = this.isEditMode ? `/users/${this.form.id}` : '/users/create';
        const method = this.isEditMode ? 'put' : 'post';
        
        const response = await api[method](endpoint, userData);

        if ([200, 201].includes(response.status)) {
          const successMsg = this.isEditMode
            ? `Usuario "${this.form.nombre_usuario}" actualizado exitosamente`
            : `Usuario "${this.form.nombre_usuario}" creado exitosamente`;
          this.successMessage = successMsg;

          // Cerrar el modal
          this.closeModal();

          // Emitir el evento para actualizar la tabla
          this.$emit('refreshTable');
        }
      } catch (error) {
        console.error('Error completo:', error);

        let errorMsg = 'Error desconocido.';
        if (error.response) {
          console.error('Datos de respuesta:', error.response.data);

          if (error.response.status === 422) {
            // Laravel suele devolver { message: '...', errors: { campo: [msg, ...] } }
            const data = error.response.data;
            if (data.errors && typeof data.errors === 'object') {
              // Unir todos los mensajes de todos los campos
              errorMsg = Object.values(data.errors).flat().map((msg, idx) => `${idx + 1}. ${msg}`).join('\n');
            } else if (data.message) {
              errorMsg = data.message;
            } else {
              errorMsg = 'Error de validación. Por favor, revisa los campos.';
            }
          } else if (error.response.data.error) {
            // Capturar mensaje general del backend
            errorMsg = error.response.data.error;
          } else if (error.response.data.message) {
            errorMsg = error.response.data.message;
          } else {
            errorMsg = `Error del servidor: ${error.response.status}`;
          }
        } else if (error.request) {
          errorMsg = 'No se recibió respuesta del servidor';
        } else {
          errorMsg = 'Error al configurar la solicitud';
        }

        // Mostrar el mensaje de error detallado con SweetAlert2
        this.showAlert(errorMsg, 'error');
      }
    },
    
    showAlert(message, type = 'error') {
      Swal.fire({
        icon: type === 'error' ? 'error' : 'success',
        title: type === 'error' ? 'Error' : 'Éxito',
        text: message,
        timer: 2500,
        showConfirmButton: false
      });
      // Log sólo en desarrollo
  if (import.meta.env.DEV) console.debug(`[${type.toUpperCase()}] ${message}`);
    },
    
    closeModal() {
      // Emitir un evento para notificar que el modal se ha cerrado
      this.$emit('close');
    },
    
    resetForm() {
      this.$emit('reset');
    },
  },
};
</script>

<style scoped>
.btn-export {
  background-color: #2e7d32;
  color: #fff;
}
.btn-export:hover {
  background-color: #1b5e20;
}

.welcome-container {
  font-family: 'Arial', sans-serif;
}

.modal-content {
  border-radius: 10px;
  border: none;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  background-color: #99172A;
  color: white;
  border-bottom: none;
  border-radius: 10px 10px 0 0;
  padding: 12px 48px !important;
  box-sizing: border-box;
  height: 64px;
  margin-top: 0;
  left: 0;
}

/* título: usar posición absoluta para centrar exactamente */
.modal-title {
  position: absolute !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
  font-weight: 600;
  font-size: 1.25rem;
  text-align: center !important;
  line-height: 1 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 160px) !important; /* espacio reservado para botones */
  pointer-events: none; /* evita solapamientos de clic */
}

/* botón: en el flujo flex del header, alineado a la derecha y centrado verticalmente */
.modal-content .modal-header .btn-close {
  position: relative !important;
  margin-left: auto !important;
  right: auto !important;
  top: auto !important;
  transform: none !important;
  width: 36px !important;
  height: 36px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: rgba(0,0,0,0.12) !important;
  border: none !important;
  z-index: 9999 !important;
}

/* forzar icono blanco */
.modal-content .modal-header .btn-close .material-icons {
  color: #fff !important;
}

.modal-body {
  padding: 20px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 15px 20px;
  align-items: center;
}

.form-label {
  font-weight: 500;
  color: #495057;
  text-align: right;
}

.required {
  color: #99172A;
  font-weight: bold;
}

.form-control {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 10px 15px;
  transition: all 0.3s;
}

.form-control:focus {
  border-color: #99172A;
  box-shadow: 0 0 0 0.25rem rgba(153, 23, 42, 0.25);
}

.password-container {
  position: relative;
  display: flex;
  align-items: center;
}

.toggle-password {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  color: #99172A;
  cursor: pointer;
}

.btn-primary {
  background-color: #99172A;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #7A1222;
}

.btn-cancel {
  background-color: #6c757d;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 44px;
  line-height: 24px;
  display: inline-block;
  vertical-align: middle;
}
.btn-cancel:hover {
  background-color: #495057;
}

.required-note {
  font-size: 0.85rem;
  color: #6c757d;
  margin-top: 15px;
}

.form-text {
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 5px;
  border: 1px solid #e9ecef;
}

.alert {
  padding: 10px 15px;
  border-radius: 5px;
  margin-top: 15px;
}

.alert-danger {
  background-color: rgba(153, 23, 42, 0.1);
  color: #99172A;
  border: 1px solid #99172A;
}

.alert-success {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
  border: 1px solid #28a745;
}

.form-check-input:checked {
  background-color: #99172A;
  border-color: #99172A;
}

.form-check-input:focus {
  box-shadow: 0 0 0 0.25rem rgba(153, 23, 42, 0.25);
}

.user-management-container {
  margin-top: 30px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 500;
}

.table td {
  vertical-align: middle;
}

.actions-column {
  width: 150px;
  text-align: center;
}

.material-icons {
  cursor: pointer;
  font-size: 1.2rem;
  transition: color 0.3s;
}

.material-icons:hover {
  color: #99172A;
}

.badge {
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 0.85rem;
}

.bg-danger {
  background-color: rgba(153, 23, 42, 0.1) !important;
  color: #99172A !important;
}

.bg-success {
  background-color: rgba(40, 167, 69, 0.1) !important;
  color: #28a745 !important;
}

.actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
  padding: 5px;
}

.icon-row-horizontal .material-icons,
.icon-row-horizontal .material-icons-outlined,
.icon-row-horizontal .material-icons-round {
  color: #99172A !important;
  font-size: 24px;
  vertical-align: middle;
  transition: color 0.2s, transform 0.2s;
  cursor: pointer;
}

.icon-row-horizontal .material-icons:hover,
.icon-row-horizontal .material-icons-outlined:hover,
.icon-row-horizontal .material-icons-round:hover {
  color: #7A1222 !important;
  transform: scale(1.1);
}

.lock-icon {
  color: #dc3545 !important;
}

.lock-icon:hover {
  color: #c82333 !important;
}

.unlock-icon {
  color: #28a745 !important;
}

.unlock-icon:hover {
  color: #218838 !important;
}

.form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

/* Fuerza alineación del título y del aspa (más específicas y con !important) */
.modal-content .modal-header {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  padding: 15px 48px !important;
  min-height: 56px !important;
}

.modal-content .modal-header .modal-title {
  margin: 0 auto !important;
  display: block !important;
  width: calc(100% - 112px) !important; /* deja hueco para el botón */
  text-align: center !important;
  line-height: 1.2 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.modal-content .modal-header .btn-close {
  position: absolute !important;
  right: 36px !important;      /* ajusta este valor para mover el aspa más a la izquierda */
  top: 56% !important;        /* bajar el botón respecto al centro del header */
  transform: translateY(-50%) !important;
  width: 36px !important;
  height: 36px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 9999 !important;
}

/* Forzar color blanco del icono por si hay reglas que lo cambian */
.modal-content .modal-header .btn-close .material-icons {
  color: #fff !important;
}
</style>